import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMetadata } from "../../seo/metadata";
import { useLanguage } from "../../context/LanguageContext";
import { languagePath } from "../../i18n/routing";

export default function PageMetadata() {
  const { pathname } = useLocation();
  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    const metadata = getMetadata(languagePath(pathname, selectedLanguage));
    document.title = metadata.title;
    document.documentElement.lang = metadata.language;
    document.documentElement.dir = metadata.direction;
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((tag) => tag.remove());
    metadata.alternates.forEach(({ language, href }) => {
      const tag = document.createElement("link");
      tag.rel = "alternate";
      tag.hreflang = language;
      tag.href = href;
      document.head.appendChild(tag);
    });
    const tags = {
      'meta[name="description"]': metadata.description,
      'meta[name="robots"]': metadata.robots,
      'meta[property="og:title"]': metadata.ogTitle,
      'meta[property="og:description"]': metadata.ogDescription,
      'meta[property="og:url"]': metadata.canonical,
      'link[rel="canonical"]': metadata.canonical,
    };
    Object.entries(tags).forEach(([selector, value]) => {
      document.head.querySelector(selector)?.setAttribute(
        selector.startsWith("link") ? "href" : "content",
        value
      );
    });
  }, [pathname, selectedLanguage]);

  return null;
}
